module.exports = __webpack_public_path__ + "media/73.b3f53e5c.wav";